import { Directive, OnDestroy, OnInit, TemplateRef, inject, input } from '@angular/core';
import { ContainerService } from '../services';
import { ContainerType } from './container.directive';

@Directive({
  selector: '[sharedTemplate]',
})
export class TemplateDirective implements OnInit, OnDestroy {
  readonly sharedTemplate = input.required<ContainerType>();

  private template = inject(TemplateRef);
  private containerService = inject(ContainerService);

  ngOnInit() {
    this.containerService.setUI(this.sharedTemplate(), this.template);
  }

  ngOnDestroy() {
    this.containerService.clearUI(this.sharedTemplate());
  }
}
